import MultiUploadManager from './MultiUploadManagerContainer'
import MultiFileDialog from './MultiUploadManager'
export { MultiFileDialog }
export default MultiUploadManager
